export class Colors {
  static Black = {
    toHexString: '#000000',
    toHexValue: 0x000000,
  };
  static Blue = {
    toHexString: '#0d58d3',
    toHexValue: 0x0d58d3,
  };
  static Purple = {
    toHexString: '#ff00ff',
    toHexValue: 0xff00ff,
  };
  static White = {
    toHexString: '#ffffff',
    toHexValue: 0xffffff,
  };
}
